<template>
  <main ref="main" role="main" class="publications">
        <article class="publication" v-for="publication in publications" :key="publication.uid">
          <header>
            <p>{{publication.title}}</p>
            <p class="date">{{ formatDate(publication.date) }}</p>
            <p class="artists" v-html="artists(publication)"></p>
            <p v-if="publication.stock == '1'"><a :href="'mailto:' + infos.email + '?subject=Order '+ publication.title +' by '+ publication.artist + '&body=Please provide the following informations to proceed. We will send you back costs and shipping informations for you to confirm.%0D%0A%0D%0A - Name:%0D%0A - Last name:%0D%0A - Adress:%0D%0A - Zip code:%0D%0A - Country:%0D%0A%0D%0A'">Order</a></p>
            <p v-else><span class="noPublication" disabled>Unavailable</span></p>
          </header>
          <div class="main-carousel" v-if="publication.files.length" @mousemove="onMouseMove(publication, $event)" @click="onClick(publication, $event)">
            <div class="carousel-cell" v-for="(file, index) in publication.files" :key="file.uid" :class="[index > 0 ? 'is-hidden' : '']">
              <img :src="file.url" :alt="file.caption">
            </div>
          </div>
		  <div class="noImage" v-else>
		  </div>
        </article>
  </main>
</template>

<script>

import Flickity from 'flickity'
require('flickity-imagesloaded')
import Utils from './../util/Utils'

export default {
  name: 'publications',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
  },
  computed: {
    publications () {
      return this.$store.getters.getPagesByType('publication')
    },
    infos () {
      return this.$store.getters.getPageByUID('infos')
		}
  },
  data () {
    return {
      title: this.$store.getters.getPageByUID('publications').title
    }
  },
  methods: {
    formatDate (inputDate) {

      let fullDate = new Date(inputDate)

      // let date = ('0' + fullDate.getDate()).slice(-2)
      // let month = ('0' + (fullDate.getMonth() + 1)).slice(-2)
      let monthString = fullDate.toLocaleString('en-gb', { month: 'long' })
      let year = fullDate.getFullYear()

      fullDate = monthString + ' ' + year
      return fullDate
		},
		artists (subpage) {
			let page = subpage
			let artists = page.artist

			artists = artists.split(',');

			let artistsString = ''
			artists.forEach( (el, i) => {
				if (i < artists.length - 1) {
					// artistsString += el + '<br>' + '<span>&#8201;✳&#8201;</span>'
					artistsString += el + '<br>' + '<span>, </span>'
					// artistsString += el + '&#8201;✳&#8201;'
				} else {
					artistsString += el
				}
			})

			// if (artists.length > 1) {
			// 	artistsString = 'Group show'
			// } else {
			// 	artistsString = artists[0]
			// }

			return artistsString
		},
		onMouseMove (publication, event) {
/*
			let width = window.innerWidth
			let height = event.currentTarget.getBoundingClientRect().height
			let mouseX = event.clientX
			let mouseY = event.offsetY
			// let widthProportion = width / event.currentTarget.childElementCount
			if (mouseY >= height) mouseY = height - 1
			if (mouseY <= 0) mouseY = 1
			// let hoverPortion = Math.floor(Utils.mapRange(mouseX, 0, width, 0, event.currentTarget.childElementCount))
			let hoverPortion = Math.floor(Utils.mapRange(mouseY, 0, height, 0, event.currentTarget.childElementCount))
			let children = event.currentTarget.children
			for (let i = 0; i < children.length; i++) {
				let child = children[i]
				child.classList.add('is-hidden')
				if (i === hoverPortion) {
					child.classList.remove('is-hidden')
				}
			}
*/
		},
		onClick (publication, event) {
		
			let shownChild
			let children = event.currentTarget.children

			for (let i = 0; i < children.length; i++) {
				let child = children[i]
				if (!child.classList.contains('is-hidden')) {
					shownChild = i
				}
			}
			console.log(shownChild)
			children[shownChild].classList.add('is-hidden')
			if (shownChild >= children.length - 1) {
				shownChild = 0
			} else {
				shownChild++
			}
			children[shownChild].classList.remove('is-hidden')
		}
  },
  mounted () {
    		this.$refs.main.focus()

		let isMobile = false

		  this.$store.watch(() => this.$store.getters.getIsMobile, (value) => {
        if (value) {
					isMobile = true
        }
			}, { immediate: true })
			
    let elems = document.querySelectorAll('.main-carousel')
    let options = {
        // options
        cellAlign: 'left',
        lazyLoad: 2,
        adaptiveHeight: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        accessibility: false,
        setGallerySize: false,
				resize: true,
				imagesLoaded: true,
				freeScroll: false,
				watchCSS: true
    }
    let optionsMobile = {
        // options
        cellAlign: 'left',
        lazyLoad: 2,
        adaptiveHeight: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: '>1',
        accessibility: false,
        setGallerySize: false,
				resize: true,
				imagesLoaded: true,
				freeScroll: false,
				watchCSS: false
    }


    let flickities = []

    // [].forEach.call(elems, elem => {
    //   let flkty = new Flickity( elem, options)
    //   // flkty.on('staticClick', () => {
    //   //   flkty.next(true, true)
    //   // })
    // })

          // [].forEach.call(elems, (elem, i) => {
          //   flickities.push(new Flickity( elem, options))
          //   flickities[i].on('staticClick', () => {
          //     flickities[i].next(true, true)
          //   })
          // })

    // this.$store.watch(() => this.$store.getters.getIsMobile, (value) => {
    //     if (value) {
    //       flickities.forEach(flkty => {
    //         flkty.destroy()
    //       })
		// 			// flickities = []
		// 			flickities = [];
		// 			[].forEach.call(elems, (elem, i) => {
    //         flickities.push(new Flickity( elem, options))
    //         flickities[i].on('staticClick', () => {
    //           flickities[i].next(true, true)
    //         })
    //       })
    //     } else {
		// 			flickities.forEach(flkty => {
    //         flkty.destroy()
    //       })
		// 			flickities = [];
		// 			[].forEach.call(elems, (elem, i) => {
    //         flickities.push(new Flickity( elem, options))
    //         flickities[i].on('staticClick', () => {
    //           flickities[i].next(true, true)
    //         })
    //       })
    //     }
		// 	}, { immediate: true })


			if (isMobile) {
					flickities = [];
					[].forEach.call(elems, (elem, i) => {
						flickities.push(new Flickity( elem, optionsMobile))
						flickities[i].on('dragStart', () => document.querySelector('main').ontouchmove = e => e.preventDefault())
 						flickities[i].on('dragEnd', () => document.querySelector('main').ontouchmove = () => true)
          })
			} else {
					flickities = [];
					[].forEach.call(elems, (elem, i) => {
            flickities.push(new Flickity( elem, options))
            // flickities[i].on('staticClick', () => {
            //   flickities[i].next(true, true)
						// })
          })
			}

    this.$store.watch(() => this.$store.getters.getTablet, (value) => {
        if (value) {
					flickities.forEach((flkty, i) => {
						if (!isMobile) {
							flkty.options.draggable = '>1'
							flkty.updateDraggable()

						}
							flkty.options.freeScroll = true
					})

        } else {
					flickities.forEach((flkty, i) => {
						if (!isMobile) {
							flkty.options.draggable = false
							flkty.updateDraggable()
						} 
							flkty.options.freeScroll = false
					})
				}
			}, { immediate: true })

  }
}
</script>

<style lang="scss">
	@import 'node_modules/flickity/dist/flickity.min';
	@import './../assets/styles/general/mixins';
	@import './../assets/styles/config';

	.main-carousel {
		@include fluid-type(400px, 1300px, 6px, 12px);
		height: 50em;
		// cursor: e-resize;
		position: relative;
		overflow: hidden;
		&:after {
				content: '';
		}
		cursor: url("~@/assets/img/arrow.png") 0 0, pointer; /* Legacy */
		cursor: url("~@/assets/img/arrow.svg") 0 0, pointer; /* FF */
		cursor: -webkit-image-set(url("~@/assets/img/arrow.png") 1x, url("~@/assets/img/arrow@2x.png") 2x) 0 0, pointer; /* Webkit */
		@media screen and (max-width: $mq-tablet) {
			// cursor: auto;

			&:after {
			  content: 'flickity';
  			display: none;
			}

			// order: 1;
			// margin-bottom: 1.5em;
			// height: auto;

			// height: auto;

			// .flickity-viewport {
			// 	will-change: height;
			// 	transition: height 0.3s ease;
			// }
			// height: 50%;
		}
	}

	body.is-mobile {
		.carousel-cell {
			top: auto !important;
			visibility: visible !important;
		}
	}

	.carousel-cell {
		// height: 100%;
		// display: inline-block;
		touch-action: manipulation;
		@include fluid-type(400px, 1300px, 11.666666px, 12px);
		// width: calc(100% - 3em - 2rem);
		width: 100%;
		height: 100%;
		padding: 0 0 0 1rem;

		position: absolute;
		top: 0;
		
		&.is-hidden {
			visibility: hidden;
				@media screen and (max-width: $mq-tablet) {
					visibility: visible;
				}
		}
		@media screen and (max-width: $mq-tablet) {
			position: static;
			top: auto;
			// padding: 0 0.5rem;
			// padding: 0;
			// cursor: auto;
			// padding-left: 1rem;
			// padding: 0;
			// cursor: auto;
			// width: 100%;
			// height: auto;
			// width: 100%;
			// min-width: calc(100% - 5em);
			width: auto;
			// width: auto;
			// width: 100%;
			// overflow: hidden;
			// width: auto;
		}
		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
			// object-position: 0 0;
			object-position: 50% 50%;
			@include fluid-type(400px, 1300px, 6px, 12px);
			@media screen and (max-width: $mq-tablet) {
				// max-height: none;
				// width: 100%;

				// width: 100vw;
				// object-fit: none;
				height: 100%;
				width: auto;
				// display: block;
			}
		}
	}

	.publication {
		margin-bottom: 2em;
		// display: flex;
		// flex-direction: column;
		&:last-child {
			margin-bottom: 0;
		}
	}

	.publications {
		padding: 1rem 0rem;
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		::-moz-selection {
			/* Code for Firefox */
			color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
			// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
			text-shadow: 0px 0px 0.1em black;
		}


		::selection {
			color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
			// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
			text-shadow: 0px 0px 0.1em black;
		}
		.noImage {
		@include fluid-type(400px, 1300px, 6px, 12px);
		height: 10em;
		}
		header {
			display: flex;
			padding: 0 1rem;
			
			// padding-bottom: 0.4rem;
			margin-bottom: 0.6em;
			@include fluid-type(400px, 1300px, 11.666666px, 12px);
			@media screen and (max-width: $mq-tablet) {
				flex-wrap: wrap;
				// order: 2;
				@include fluid-type(400px, 1300px, 5.888888888px, 12px);
			}

			p {
				// width: 25%;
				padding-right: 1em;
				line-height: 1.2;
					// font-size: 1.5rem;
							font-size: 1.4rem;
		font-family: Arial;
		font-weight: bold;
				@media screen and (max-width: $mq-tablet) {
					// font-size: 3em;
				}
				&:nth-child(1) {
					width: 25%;
					@media screen and (max-width: $mq-tablet) {
						width: 100%;
					}
				}
				&:nth-child(2) {
					width: 25%;
					@media screen and (max-width: $mq-tablet) {
						width: 100%;
						margin-bottom: 0.6em;
					}
				}
				&:nth-child(3) {
					width: 32%;

					@media screen and (max-width: $mq-tablet) {
						width: 100%;
					}
				}
				&:last-child {
					width: 18%;
					// margin-left: auto;
					padding-right: 0;
					text-align: right;
					@media screen and (max-width: $mq-tablet) {
						width: 100%;
						margin: 0.3em 0;
						// margin-top: 1em;
					}
				}
			}
			.date {
				font-variant-numeric: tabular-nums;
			}
			.artists {
				span {
					display: none;
				}
					@media screen and (max-width: $mq-tablet) {
						br {
							display: none;
						}
						span {
							display: inline;
						}
					}
			}
			a, .noPublication {
				background: rgb(216, 216, 216);
				// padding: 0.3rem 2rem 0.1rem 2rem;
				padding: 0.3em 2em 0.1em 2em;
				border-radius: 3rem;
				font-size: 1.4rem;
						font-family: Arial;
		font-weight: bold;
				border: 0;
				display: inline;
				white-space: nowrap;
				@media screen and (max-width: $mq-tablet) {
					display: block;
					width: 100%;
				}
				text-align: center;
				&:hover {
					background: black;
					color: white;
				}
			}
			.noPublication {
				color: rgb(170, 170, 170);
				background: rgb(240, 240, 240);
				padding: 0.3em 0.8em 0.1em 0.8em;
				cursor: not-allowed;
				&:hover {
					color: rgb(170, 170, 170);
					background: rgb(240, 240, 240);
				}
			}
		}
	}
</style>
